import { Accordion as BaseAccordion } from '@base-ui/react/accordion';
import styled from '@emotion/styled';
import { alpha } from '@mui/system';

import {
  DISABLED_EXCLUSIONS,
  DISABLED_SELECTORS,
  focusRing,
} from '@/design-system/interaction-states';
import { forHover } from '@/design-system/responsive';
import { typographyVariantStyles } from '@/design-system/typography-variants';

export const StyledRoot = styled(BaseAccordion.Root)({
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
});

export const StyledItem = styled(BaseAccordion.Item)(({ theme }) => ({
  borderBottom: `1px solid ${theme.colors.border.default}`,
  transition: theme.motion.hover,

  [forHover]: {
    '&:has(button:hover):not([data-disabled])': {
      borderBottomColor: theme.colors.border.strong,
    },
  },

  '&[data-open]': {
    borderBottomColor: 'transparent',
  },

  '&:has(button:focus-visible)': {
    borderBottomColor: 'transparent',
  },

  '&[data-disabled]': {
    cursor: 'not-allowed',
  },
}));

export const StyledHeader = styled(BaseAccordion.Header)({
  margin: 0,
  padding: 0,
});

export const StyledTrigger = styled(BaseAccordion.Trigger)(({ theme }) => ({
  ...typographyVariantStyles.body2,

  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  padding: '16px 0',
  backgroundColor: 'transparent',
  border: 'none',
  cursor: 'pointer',
  color: theme.colors.text.primary,
  boxSizing: 'border-box',
  outline: 'none',
  borderRadius: '8px',

  ...focusRing(theme),

  [DISABLED_SELECTORS]: {
    cursor: 'not-allowed',
    color: theme.colors.text.disabled,
  },
}));

export const StyledPanel = styled(BaseAccordion.Panel)(({ theme }) => ({
  boxSizing: 'border-box',
  height: 'var(--accordion-panel-height)',
  overflow: 'hidden',
  ...typographyVariantStyles.body2,
  color: alpha(theme.colors.text.primary, 0.6),
  transition: 'height 150ms ease-out',

  '&[data-starting-style], &[data-ending-style]': {
    height: 0,
  },
}));

export const TriggerChevron = styled('span')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
  color: theme.colors.text.secondary,
  transition: `transform 0.2s ease, ${theme.motion.hover}`,

  '[data-panel-open] &': {
    transform: 'rotate(180deg)',
  },

  [forHover]: {
    [`button:hover${DISABLED_EXCLUSIONS} &`]: {
      color: theme.colors.text.primary,
    },
  },

  '[data-disabled] &': {
    opacity: 0.4,
  },
}));
